import type { SummaryActiveRun } from '@platform/summary-ui';

export type FeedbackTarget =
  | { kind: 'artifact'; artifactId: string }
  | { kind: 'run'; runId: string }
  | null;

function normalized(value: string | null | undefined): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function resolveFeedbackTarget(params: {
  selectedArtifactId?: string | null;
  activeRun?: SummaryActiveRun | null;
}): FeedbackTarget {
  const runID = normalized(params.activeRun?.stableId);
  const runArtifactID = normalized(params.activeRun?.artifactId);
  if (runID !== '' && runArtifactID === '') {
    return { kind: 'run', runId: runID };
  }

  const artifactID = normalized(params.selectedArtifactId);
  if (artifactID !== '') {
    return { kind: 'artifact', artifactId: artifactID };
  }

  return null;
}
